import { motion } from "framer-motion";

export const SectionHeading = ({ label, title, desc }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.5 }}
    className="max-w-2xl space-y-3"
  >
    <p className="font-mono text-xs uppercase tracking-[0.25em] text-rose-400">{label}</p>
    <h2 className="font-heading text-3xl font-bold uppercase leading-none tracking-tight text-white sm:text-4xl lg:text-5xl">
      {title}
    </h2>
    {desc && <p className="text-base leading-relaxed text-slate-400 md:text-lg">{desc}</p>}
  </motion.div>
);
